<template>
  <input
    :id="settingId"
    v-model="modelValue"
    type="number"
    :autofocus="autofocus"
    :required="required"
    class="design-system-input block w-full rounded-lg border border-solid p-2.5 py-1.5 text-sm"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { useSettingControl } from "@/components/Setting/context";

const props = defineProps<{
  modelValue?: number;
  autofocus?: boolean;
  required?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [next: number];
}>();

const modelValue = computed({
  get(): number | undefined {
    return props.modelValue;
  },
  set(next: number | "") {
    if (next === "") {
      // @ts-expect-error
      emit("update:modelValue", null);
    } else {
      emit("update:modelValue", next);
    }
  },
});

const setting = useSettingControl();
const settingId = setting?.register();
</script>
